import { render, staticRenderFns } from "./BasicUserInfo.vue?vue&type=template&id=28703c97&"
import script from "./BasicUserInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./BasicUserInfo.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports